import './App.css';
import Login from "./components/login";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Register from "./components/register";
import NewWineEntry from "./components/newWineEntry";
import WineList from "./components/wineList";

function App() {
    return (
        <div className="App">
            <BrowserRouter basename="/portail-vin">
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/new-entry" element={<NewWineEntry />} />
                    <Route path="/wine-list" element={<WineList />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
